<div id="loader" *ngIf="isLoader">
    <div id="shadow"></div>
    <div id="box"></div>
    <h4><b>Loading..</b></h4>
</div>
<div *ngIf="body">
    <mat-card style="background: transparent;">
        <mat-card class="card_style">

            <div>

                <div style="text-align: center; padding-top: 50px;">

                    <h1 style="margin-top: 10px; margin-bottom: 20px;"><b>Marketing Visit</b></h1>





                </div>
            </div>

            <div class="row mb-2 ">
                <div class="col-sm-6">
            
                    <div class="input-group" style="width: 70%;">
                        <input  type="search" class="form-control " placeholder="Search Employee" id="search" name="search" [(ngModel)]="search" (ngModelChange)="Search();">
                        <div class="input-group-append">
                        <button type="submit" class="btn  btn-default " (click)="Search();">
                        <i class="fa fa-search"></i>
                        </button>
                        </div>
                    </div>
                </div>
                <div class="col-sm-6">
                    <div>
                        <img class="excel-button" src="https://cdn-icons-png.flaticon.com/128/732/732220.png" width="35"
                            height="35" (click)="excelExport()">
                    </div>
            </div>
            <br>
                    <div class="table-responsive" style="margin-top: 25px;">
                        <table class="table" id="MKV">
                            <thead >
                                <tr>

                                    <th scope="col" style="width: 40%;">Sequence No</th>
                                    <th scope="col" style="width: 40%;">Customer Name</th>
                                    <th scope="col" style="width: 40%;">Created By</th>
                                    <th scope="col" style="width: 40%;">Brand Name</th>
                                    <th scope="col" style="width: 40%;">Emirates</th>
                                    <th scope="col" style="width: 40%;">Area</th>
                                    <th scope="col" style="width: 40%;">Location</th>
                                    <th scope="col" style="width: 40%;">Customer Industry</th>
                                    <th scope="col" style="width: 40%;">Supplier</th>
                                    <th scope="col" style="width: 40%;">No Of Painters</th>
                                    <th scope="col" style="width: 40%;">Monthly Volume</th>
                                    <th scope="col" style="width: 40%;">Whatsapp No</th>
                                
                                </tr>
                            </thead>
                            <tbody  >
                                <ng-container *ngFor="let employee of output">
                                    <tr>
                                        <td>{{ employee.sequence_no }}</td>
                                        <td>{{ employee.customer_name }}</td>
                                        <td>{{ employee.created_by_name }}</td>
                                        <td>{{ employee.brand_name }}</td>
                                        <td>{{ employee.emirates }}</td>
                                        <td>{{ employee.area }}</td>
                                        <td>{{ employee.location }}</td>
                                        <td>{{ employee.customer_industry }}</td>
                                        <td>{{ employee.supplier }}</td>
                                        <td>{{ employee.no_of_painters }}</td>
                                        <td>{{ employee.monthly_volume }}</td>
                                        <td>{{ employee.whatsapp_no }}</td>

                                    </tr>
                                </ng-container>
                            </tbody>
                        </table>
                    </div>
